
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export interface LabeledInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  labelClassName?: string;
  error?: string;
  icon?: React.ReactNode;
  wrapperClassName?: string;
}

const LabeledInput = React.forwardRef<HTMLInputElement, LabeledInputProps>(
  ({ label, labelClassName, error, className, icon, wrapperClassName, required, ...props }, ref) => {
    const id = props.id || `input-${Math.random().toString(36).substring(2, 9)}`;

    return (
      <div className={cn("space-y-2", wrapperClassName)}>
        <Label 
          htmlFor={id} 
          className={cn(
            "flex items-center gap-2", 
            error && "text-destructive",
            labelClassName
          )}
        >
          {icon && icon}
          {label}
          {required && <span className="text-destructive">*</span>}
        </Label>
        
        <div className="relative">
          {props.type === "number" && props.min === undefined && (
            // Add sensible defaults for number inputs
            <Input id={id} className={className} ref={ref} min={0} required={required} {...props} />
          )}
          {props.type === "number" && props.min !== undefined && (
            <Input id={id} className={className} ref={ref} required={required} {...props} />
          )}
          {props.type !== "number" && (
            <Input id={id} className={className} ref={ref} required={required} {...props} />
          )}
        </div>
        
        {error && (
          <p className="text-sm font-medium text-destructive">{error}</p>
        )}
      </div>
    );
  }
);

LabeledInput.displayName = "LabeledInput";

export { LabeledInput };
